const fixture = {
  onFacebookAccountClick: () => alert("LOGIN VIA FACEBOOK"),
  onGoogleAccountClick: () => alert("LOGIN VIA GOOGLE"),
};

export default fixture;
